import React, { useEffect, useRef, useContext, useState } from 'react';
import PropTypes from 'prop-types';

import PaymentContext from 'Components/Payment/payment-context';

export default function WeChatPayment({ method, isOpen }) {
  const {
    checkout,
    apipayment,
  } = useContext(PaymentContext);
  const wechatRef = useRef(null);

  const [adyenComponent, setAdyenComponent] = useState(false);

  useEffect(() => {
    if (isOpen && !adyenComponent) {
      const component = checkout.create('wechatpayQR', { paymentData: apipayment, shouldRedirectOnMobile: true });
      component.mount(wechatRef.current);
      setAdyenComponent(component);
    }
  }, [
    checkout,
    isOpen,
    method,
    adyenComponent,
    apipayment,
  ]);

  return (
    <div className="payment-option-collapse">
      <div ref={wechatRef} />
    </div>
  );
}

WeChatPayment.propTypes = {
  method: PropTypes.shape({}).isRequired,
  isOpen: PropTypes.bool,
};

WeChatPayment.defaultProps = {
  isOpen: false,
};
